import { isUndNullEmp } from '../../helpers/main.js';

export class RoleUser {
    constructor(
        _userId = '',
        _roleId = '',
        _register = '',
    ) {
        this.userId = _userId;
        this.roleId = _roleId;
        this.register = _register;
    }

    static getClassName = () => {
        return 'RoleUser - class';
    }

    static minMaxLength = (upperCase = false) => {
        if (upperCase) {
            return {
                min: {
                    UserId: 10,
                    RoleId: 10,
                    Register: 10,
                },
                max: {
                    UserId: 450,
                    RoleId: 450,
                    Register: 30,
                },
            };
        } else {
            return {
                min: {
                    userId: 10,
                    roleId: 4,
                    register: 10,
                },
                max: {
                    userId: 450,
                    roleId: 256,
                    register: 30,
                },
            };
        }
    }

    static class = (obj = {}, upperCase = false) => {
        if (!isUndNullEmp({ data: obj, subMethod: RoleUser.getClassName() })?.result) {
            if (upperCase) {
                return new RoleUser(
                    obj.UserId,
                    obj.RoleId,
                    obj.Register,
                );
            } else {
                return new RoleUser(
                    obj.userId,
                    obj.roleId,
                    obj.register,
                );
            }
        } else {
            return new RoleUser();
        }
    }
}